// extracted by mini-css-extract-plugin
module.exports = {"filterInputsContainer":"Invoices_filterInputsContainer__2iyfG","inputs":"Invoices_inputs__3nfbb"};